//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DatePicker from '../../../../components/datePicker/index.js';

import CalendarDate from './calendar/calendarDate.vue';
import CalendarMonth from './calendar/calendarMonth.vue';
import CalendarYear from './calendar/calendarYear.vue';

export default {
  components: {
    CalendarDate,
    CalendarMonth,
    CalendarYear,
  },
  extends: DatePicker,
};
